import { computed } from 'mobx';
import Model from '~/models/Model';

export default class RightModel extends Model<IRight> {
  @computed
  get key() {
    return this.get('id');
  }
}
